<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <nb-card>
        <nb-card-header class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            <nb-icon icon="shopping-cart-outline" class="me-2"></nb-icon>
            Orders
          </h4>
          <span class="badge badge-info">Receipt Auditor</span>
        </nb-card-header>

        <nb-card-body>
          <!-- Loading State -->
          <div *ngIf="loading" class="text-center py-5">
            <nb-spinner size="large"></nb-spinner>
            <p class="mt-3 text-muted">Loading stores...</p>
          </div>

          <!-- No Stores Found -->
          <div *ngIf="!loading && stores.length === 0" class="text-center py-5">
            <nb-icon icon="alert-triangle-outline" class="text-warning" style="font-size: 48px;"></nb-icon>
            <h5 class="mt-3">No Stores Assigned</h5>
            <p class="text-muted">No stores are assigned to your account. Please contact your administrator.</p>
          </div>

          <!-- Multiple Stores — Selection Grid -->
          <div *ngIf="!loading && stores.length > 1">
            <div class="mb-4">
              <h5 class="text-muted">Select a store to view its orders:</h5>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-6 mb-4" *ngFor="let store of stores">
                <nb-card
                  class="store-card h-100"
                  (click)="openOrders(store._id)">
                  <nb-card-body class="text-center">
                    <div class="mb-3">
                      <nb-icon
                        icon="shopping-cart-outline"
                        class="text-primary"
                        style="font-size: 48px;">
                      </nb-icon>
                    </div>

                    <h6 class="mb-2">{{ store.storeName }}</h6>
                    <p class="text-muted small mb-3">{{ store.address }}</p>

                    <div class="mb-3">
                      <span [class]="getStoreStatusClass(store)">
                        {{ getStoreStatusText(store) }}
                      </span>
                    </div>

                    <button
                      type="button"
                      class="btn btn-primary btn-sm w-100"
                      (click)="openOrders(store._id)">
                      <nb-icon icon="arrow-forward-outline" class="me-1"></nb-icon>
                      View Orders
                    </button>
                  </nb-card-body>
                </nb-card>
              </div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
</div>
